import { Helmet } from 'react-helmet';
import RoyaleSpacesSchema from './schema';

const SEO = ({ title, description, schema = RoyaleSpacesSchema }) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export default SEO;
